export default __webpack_public_path__ + "static/gitlab_icon-6b5b326d0cd8f915ea23293a11c8ea15.png";